import React from 'react';
import { Card, Alert, Button } from 'antd';
import { useNavigate } from "react-router-dom";

const Unauthorized401 = () => {
    const navigate = useNavigate();

    return (
        <Card style={{ maxWidth: 600, margin: "50px auto", textAlign: "center" }}>
            <Alert
                message="401 - Unauthorized"
                description="You must log in to access this page. Please sign in and try again."
                type="warning"
                showIcon
            />
            <Button type="primary" style={{ marginTop: 20 }} onClick={() => navigate("/")}>
                Back to home page
            </Button>
        </Card>
    );
};

export default Unauthorized401;
